module.exports = __webpack_public_path__ + "img/logo.7d503214.png";